import { Inject, Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { APP_CONFIG, AppConfiguration } from '@app/infrastructure/auth/app-configuration';

@Injectable({
	providedIn: 'root',
})
export class ComponentsOverviewGuard implements CanLoad {
	constructor(private router: Router, @Inject(APP_CONFIG) private appConfig: AppConfiguration) {}

	public canLoad(): boolean {
		if (this.appConfig.includeComponentsOverview) {
			return true;
		} else {
			void this.router.navigate([AppRouteHelper.notFound]);
			return false;
		}
	}
}
